export * from './User'
export * from './Auth'
export * from './Hero'
export * from './Category'
export * from './Material'
export * from './Dashboard'
export * from './Step'
export * from './StepType'
export * from './PresetGroup'
export * from './PresetCategory'
export * from './Preset'
export * from './BarcodeProduct'
export * from './BarcodeProductCategory'
export * from './News'
export * from './Log'
export * from './HeroConfig'



// WEBPACK FOOTER //
// ./src/graphql/queries/index.js